/** 大横琴畅联 - 酒店改价规则 */

export const STATUS_OPTIONS = [
  { label: '启用', value: 1 },
  { label: '禁用', value: 0 }
]

/** 计算类型：1固定金额加减，2按比例计算 */
export const CALC_TYPE_OPTIONS = [
  { label: '固定金额加减', value: 1 },
  { label: '按比例计算', value: 2 }
]

export const searchOptions = [
  {
    name: '大横琴价格计划ID',
    key: 'rateplanId',
    type: 'input',
    placeholder: '请输入大横琴价格计划ID'
  },
  {
    name: '酒店名称',
    key: 'hotelName',
    type: 'input',
    placeholder: '请输入酒店名称'
  },
  {
    name: '生效日期',
    key: 'effectiveDate',
    type: 'date',
    placeholder: '请选择生效日期'
  },
  {
    name: '状态',
    key: 'status',
    type: 'select',
    placeholder: '请选择',
    selectOptions: STATUS_OPTIONS
  }
]

export const tableColumns = [
  {
    title: '酒店名',
    dataIndex: 'hotelName',
    width: '220px',
    ellipsis: true
  },
  {
    title: '价格计划',
    dataIndex: 'rateplanName',
    width: '220px',
    scopedSlots: { customRender: 'rateplanNameSlot' }
  },
  {
    title: '大横琴价格计划ID',
    dataIndex: 'rateplanId',
    width: '160px'
  },
  {
    title: '大横琴账号',
    dataIndex: 'accountName',
    width: '180px',
    ellipsis: true
  },
  {
    title: '计算方式',
    dataIndex: 'calcTypeName',
    width: '140px'
  },
  {
    title: '调整值',
    dataIndex: 'adjustValueText',
    width: '120px'
  },
  {
    title: '状态',
    dataIndex: 'statusName',
    width: '100px'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: '160px',
    fixed: 'right',
    scopedSlots: { customRender: 'action' }
  }
]

export const editConfigList = [
  {
    name: '绑定大横琴账号',
    key: 'accountId',
    placeholder: '请选择大横琴账号',
    slot: true
  },
  {
    name: '规则名称',
    key: 'ruleName',
    placeholder: '请输入规则名称'
  },
  {
    name: '酒店名称',
    key: 'hotelId',
    placeholder: '请选择酒店名称',
    slot: true
  },
  {
    name: '价格计划名称',
    key: 'rateplanId',
    placeholder: '请选择价格计划名称',
    slot: true
  },
  {
    name: '生效日期',
    key: 'dateRange',
    placeholder: '请选择生效日期',
    slot: true
  },
  {
    name: '计算方式',
    key: 'calcType',
    placeholder: '请选择计算方式',
    slot: true
  },
  {
    name: '调整金额（元）',
    key: 'adjustValue',
    placeholder: '请输入调整金额（元）',
    slot: true
  }
]
